export default __webpack_public_path__ + "static/media/grafema_f1rst_08.4b066b3d.jpg";